import { NgModule } from '@angular/core';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { BmsjHipsterSharedModule } from '../shared';
import { RouterModule } from '@angular/router';
import { HEAD_TO_HEAD_QUERY_ROUTES } from './head-to-head-query.routes';
import { HeadToHeadQueryComponent } from './head-to-head-query.component';
import { HeadToHeadQueryService } from './head-to-head-query.service';
import {
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle
} from '@angular/material/expansion';
import { HeadToHeadQueryContext } from './head-to-head-query-context';
import { SpecifyEntriesStepComponent } from './specify-entries-step/specify-entries-step.component';
import { SpecifyEntriesTabComponent } from './specify-entries-step/specify-entries-tab.component';
import { ExpandableCellComponent } from '../shared/component/expandable-cell.component';
import { TruncateSpanComponent } from '../shared/util/span-truncate/truncate-span.component';
import { SelectTraitsStepComponent } from './select-traits-step/select-traits-step.component';
import { SelectionCountComponent } from '../shared/selection-count/selection-count.component';
import { SelectEnvironmentsStepComponent } from './select-environments-step/select-environments-step.component';
import { QueryService } from '../shared/query/service/query.service';
import { DisplayResultsComponent } from './display-results/display-results.component';
import { VariableResultsTabComponent } from './display-results/variable-results-tab.component';
import { HelpLinkComponent } from '../shared/help-link/help-link.component';

@NgModule({
    imports: [
        DragDropModule,
        BmsjHipsterSharedModule,
        RouterModule.forChild(HEAD_TO_HEAD_QUERY_ROUTES),
        MatAccordion,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        MatExpansionPanelTitle,
        ExpandableCellComponent,
        TruncateSpanComponent,
        SelectionCountComponent,
        HelpLinkComponent
    ],
    declarations: [
        HeadToHeadQueryComponent,
        SpecifyEntriesStepComponent,
        SpecifyEntriesTabComponent,
        SelectTraitsStepComponent,
        SelectEnvironmentsStepComponent,
        DisplayResultsComponent,
        VariableResultsTabComponent
    ],
    providers: [
        QueryService,
        HeadToHeadQueryService,
        HeadToHeadQueryContext
    ]
})
export class HeadToHeadQueryModule {
}
